export const AI_PROVIDERS = [
  {
    name: "openai",
    models: [
      "gpt-5.1",
      "gpt-5.1-codex-max",
      "gpt-5",
      "gpt-5-mini",
      "gpt-5-nano",
      "gpt-5-chat-latest",
      "gpt-4o",
      "gpt-3.5-turbo",
    ]
  },
  {
    name: "claude",
    models: [
      "claude-sonnet-4.5",
      "claude-opus-4.1",
      "claude-sonnet-4",
      "claude-haiku-4.5",
      "claude-3.5-sonnet-20241022",
      "claude-3-opus-20240229",
    ]
  },
  {
    name: "gemini",
    models: [
      "gemini-3-pro-preview",
      "gemini-3-deep-think",
      "gemini-2.5-pro",
      "gemini-2.5-flash",
      "gemini-2.0-flash",
      "gemma-3-4b",
    ]
  },
  {
    name: "deepseek",
    models: [
      "deepseek-v3.2",
      "deepseek-v3.1",
      "deepseek-r1-0528",
      "deepseek-r1",
      "deepseek-v3-0324",
      "deepseek-v3",
      "deepseek-coder",
    ]
  },
  {
    name: "mistral",
    models: [
      "mistral-medium-3.1",
      "mistral-small-3.2",
      "mistral-large-2.1",
      "pixtral-large-2411",
      "codestral-2508",
      "mistral-saba-2502",
      "voxtral-small-2507",
      "voxtral-mini-2507",
      "magistral-medium-2509",
      "magistral-small-2509",
    ]
  },
  {
    name: "llama",
    models: [
      "llama-4-maverick",
      "llama-4-scout",
      "llama-4-behemoth",
      "llama-3.3-70b-instruct",
      "llama-3.2-90b-vision-instruct",
    ]
  },
  {
    name: "cohere",
    models: [
      "command-a",
      "command-a-reasoning",
      "command-a-vision",
      "command-a-translate",
      "command-r7b",
      "command-r+",
      "command-r",
      "command-r-08-2024",
    ]
  }
];

export const getModelsByProvider = (providerName) => {
  if (!providerName) return [];
  const provider = AI_PROVIDERS.find(p => p.name.toLowerCase() === providerName.toLowerCase());
  return provider ? provider.models : [];
};

export const getProviderNames = () => {
  return AI_PROVIDERS.map(p => p.name);
};

export const isValidModel = (providerName, modelName) => {
  const models = getModelsByProvider(providerName);
  return models.includes(modelName);
};

export const IMAGE_DIMENSIONS = [
  { resolution: "1024x1024", type: "square" },
  { resolution: "1536x1024", type: "landscape" },
  { resolution: "1024x1536", type: "portrait" }
];

export const GEMINI_ASPECT_RATIOS = [
  "1:1",
  "2:3",
  "3:2",
  "3:4",
  "4:3",
  "4:5",
  "5:4",
  "9:16",
  "16:9",
  "21:9"
];

export const GEMINI_IMAGE_SIZES = [
  "1k",
  "2k",
  "4k"
];

export const shouldShowImageDimensions = (agentId) => {
  return agentId && agentId.toLowerCase().includes('image');
};

export const getImageFieldsConfig = (agentId, providerAi) => {
  const isImageAgent = shouldShowImageDimensions(agentId);
  
  if (!isImageAgent) {
    return { showFields: false, provider: null };
  }

  const provider = providerAi?.toLowerCase();
  
  if (provider === 'openai') {
    return { showFields: true, provider: 'openai' };
  }
  
  if (provider === 'gemini') {
    return { showFields: true, provider: 'gemini' };
  }
  
  return { showFields: false, provider: null };
};
